import { useTranslation } from 'next-i18next';
import React from 'react';
import { TeamHeroMenuComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import SlideMenu from '../SlideMenu';

const TeamHeroMenuUiComponent = ({ uiComponent }: UiComponentElementInterface<TeamHeroMenuComponentInterface>) => {
  const { t } = useTranslation();

  return (
    <div
      className={`relative transition-all w-full`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <div className={`bg-transparent z-20 ${uiComponent?.customStyling?.topSpace ? 'pt-32 pb-32' : ''} `}>
        <h1 className="text-center text-2xl @sm:text-3xl font-semibold">
          <span
            dangerouslySetInnerHTML={{
              __html: uiComponent?.preText ?? '',
            }}
          />
          &nbsp;
          {
            // check if string only contains spaces
            /\S/.test(uiComponent?.postText || '') && (
              <span
                className="px-2 bg-buttons-main"
                dangerouslySetInnerHTML={{
                  __html: uiComponent?.postText || '',
                }}
              />
            )
          }
        </h1>
        {/* <PBSlideMenu uiComponent={uiComponent} className="mt-12" /> */}
        <SlideMenu
          className="mt-12"
          items={uiComponent?.items}
          textColor={uiComponent?.customStyling.ItemTextColor}
          backgroundColor={uiComponent?.customStyling.menuBackgroundColor}
        />
      </div>
    </div>
  );
};

export default TeamHeroMenuUiComponent;
